/**
 * Maps restaurant UUID (per Supabase project) to theme source environment.
 * Source code lives under by-restaurant/<env>/<slug>/ — not under UUID folders.
 *
 * @see by-restaurant/README.md
 */

/** @type {Record<string, 'staging' | 'production'>} */
export const RESTAURANT_THEME_ENV = {
  // Arika's Ram Nagari
  '87e20056-d1e8-4337-9333-3063a5582e2d': 'staging',
  '156f958b-5075-44dd-92c9-0112955c2c9c': 'production',
  // Casa Azul (staging demo restaurant)
  '8ecc8e4d-f3bf-4116-9010-3436ec1a5baa': 'staging',
};

/**
 * @param {string | null | undefined} restaurantId
 * @returns {'staging' | 'production' | null}
 */
export function getThemeEnvForRestaurant(restaurantId) {
  if (!restaurantId) return null;
  return RESTAURANT_THEME_ENV[restaurantId] || null;
}

/**
 * Canonical codebase path shown in admin + docs.
 * @param {string} restaurantId
 * @param {string} slug
 */
export function getThemeCodebasePath(restaurantId, slug) {
  const env = getThemeEnvForRestaurant(restaurantId);
  if (env && slug) {
    return `by-restaurant/${env}/${slug}/`;
  }
  return `by-restaurant/${restaurantId}/${slug}/`;
}
